import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pullRequests: {
    id: 'frontbucket.repository.pullRequest.breadcrumbs.pullRequests',
    description: 'Text to display on pull requests breadcrumbs',
    defaultMessage: 'Pull Requests',
  },
  createPullRequestsTitle: {
    id: 'frontbucket.repository.pullRequest.title.createPullRequestsTitle',
    description: 'Text to display as the title on the create pull request page',
    defaultMessage: 'Create a Pull Request',
  },
  title: {
    id: 'frontbucket.repository.pullRequest.title.createPullRequest',
    description: 'Text to display on the title field to create pull request',
    defaultMessage: 'Title',
  },
  description: {
    id: 'frontbucket.repository.pullRequest.description.createPullRequest',
    description:
      'Text to display on the description field to create pull request',
    defaultMessage: 'Description',
  },
  createPullRequest: {
    id: 'frontbucket.repository.pullRequest.button.createPullRequest',
    description: 'Text to display on the button to create pull request',
    defaultMessage: 'Create pull request',
  },
  createDraft: {
    id: 'frontbucket.repository.pullRequest.button.createDraft',
    description: 'Text to display on the button to create a draft pull request',
    defaultMessage: 'Create draft',
  },
  cancel: {
    id: 'frontbucket.repository.pullRequest.button.cancel',
    description:
      'Text to display on the button to cancel creating a pull request',
    defaultMessage: 'Cancel',
  },
  errorTitle: {
    id: 'frontbucket.repository.pullRequest.title.errorTitle',
    description:
      'Title text to display when an error ocurres creating a pull request',
    defaultMessage: 'Something went wrong',
  },
  errorBody: {
    id: 'frontbucket.repository.pullRequest.body.errorBody',
    description:
      'Body text to display when an error occurs creating a pull request',
    defaultMessage:
      'We are unable to create your pull request at this time. Refresh the page, or try again later.',
  },
  titleTooLong: {
    id: 'frontbucket.repository.pullRequest.title.titleTooLong',
    description: 'Text to display when PR Title is too long',
    defaultMessage:
      'This pull request title is too long. Titles must be less than 255 characters.',
  },
  errorOnSourceLoad: {
    id: 'frontbucket.repository.pullRequest.error.errorOnSourceLoad',
    description:
      'Text to display when there is an error loading a provided source branch',
    defaultMessage: 'Error loading source branch: {sourceBranch}',
  },
  errorOnDestLoad: {
    id: 'frontbucket.repository.pullRequest.error.errorOnDestLoad',
    description:
      'Text to display when there is an error loading a provided destination branch',
    defaultMessage: 'Error loading destination branch: {destinationBranch}',
  },
  errorOnSourceAndDestLoad: {
    id: 'frontbucket.repository.pullRequest.error.errorOnSourceAndDestLoad',
    description:
      'Text to display when there is an error loading the provided source and dest branches',
    defaultMessage:
      'Error loading source and destination branches: {sourceBranch} & {destinationBranch}',
  },
  deleteBranchTitle: {
    id: 'frontbucket.repository.pullRequest.title.deleteBranch',
    description: 'Text to display on the delete branch checkbox field',
    defaultMessage: 'Delete branch',
  },
  deleteBranchPreLabel: {
    id: 'frontbucket.repository.pullRequest.label.deleteBranchPreLabel',
    description: 'Text to display next to the delete branch checkbox (part 1)',
    defaultMessage: 'Delete',
  },
  deleteBranchPostLabel: {
    id: 'frontbucket.repository.pullRequest.label.deleteBranchPostLabel',
    description: 'Text to display next to the delete branch checkbox (part 2)',
    defaultMessage: 'after the pull request is merged',
  },
  pullRequestExistsTitle: {
    id: 'frontbucket.repository.pullRequest.title.pullRequestExists',
    description:
      'Text to display as the title of the section message for a pull request that already exists',
    defaultMessage: 'Pull request exists',
  },
  pullRequestExistsDescription: {
    id: 'frontbucket.repository.pullRequest.description.pullRequestExists',
    description:
      'Text to display as the body of the section message for a pull request that already exists',
    defaultMessage:
      'There is already an open pull request between the selected branches.',
  },
  pullRequestExistsLink: {
    id: 'frontbucket.repository.pullRequest.link.pullRequestExists',
    description: 'Action to view the existing pull request',
    defaultMessage: 'View pull request',
  },
  pullRequestCreationLockedTitle: {
    id: 'frontbucket.repository.pullRequest.title.pullRequestCreationLocked',
    description:
      'Text to display as the body of the section message for when pull request creation is locked for a workspace',
    defaultMessage: 'Pull request creation locked',
  },
  pullRequestCreationLockedDescription: {
    id: 'frontbucket.repository.pullRequest.description.pullRequestCreationLocked',
    description:
      'Text to display as the body of the section message for when pull request creation is locked for a workspace',
    defaultMessage:
      'Pull request creation is temporarily unavailable for this workspace.',
  },
  branchDeletionDisabledTooltip: {
    id: 'frontbucket.repository.pullRequest.tooltip.branchDeletionDisabledTooltip',
    description:
      'Message when delete is disabled on delete checkbox on the PR Create page',
    defaultMessage: 'Branch deletion is disabled for this branch.',
  },
  copyBranchPRTitle: {
    id: 'frontbucket.repository.pullRequest.tooltip.copyBranchPRTitle',
    description:
      'Default PR title for pull requests that copy a branch across repositories',
    defaultMessage: 'Copy {branchName} branch',
  },
  newBranchName: {
    id: 'frontbucket.repository.pullRequest.tooltip.newBranchName',
    description:
      'Displayed in the dropdown as an option to create a new branch when one with this name currently does not exist',
    defaultMessage: '{branchName} (new branch)',
  },
  sourceBranchLabel: {
    id: 'frontbucket.repository.pullRequest.branchSelector.sourceBranchLabel',
    description: 'Label that is displayed on the Source Branch Selector',
    defaultMessage: 'Source Branch',
  },
  destinationBranchLabel: {
    id: 'frontbucket.repository.pullRequest.branchSelector.destinationBranchLabel',
    description: 'Label that is displayed on the Destination Branch Selector',
    defaultMessage: 'Destination Branch',
  },
  sourceRepoLabel: {
    id: 'frontbucket.repository.pullRequest.branchSelector.sourceRepoLabel',
    description: 'Label that is displayed on the Source Repository Selector',
    defaultMessage: 'Source Repository',
  },
  destinationRepoLabel: {
    id: 'frontbucket.repository.pullRequest.branchSelector.destinationRepoLabel',
    description:
      'Label that is displayed on the Destination Repository Selector',
    defaultMessage: 'Destination Repository',
  },
  reviewers: {
    id: 'frontbucket.repository.pullRequest.reviewers.title.createPullRequest',
    description:
      'Title to display on the reviewers field to create pull request',
    defaultMessage: 'Reviewers',
  },
  reviewGroups: {
    id: 'frontbucket.repository.pullRequest.reviewGroups.title.createPullRequest',
    description:
      'Title to display on the review groups field to create pull request',
    defaultMessage: 'Review groups',
  },
  reviewersPlaceholder: {
    id: 'frontbucket.repository.pullRequest.reviewers.placeholder.createPullRequest',
    description:
      'Placeholder text to display on the reviewers field to create pull request',
    defaultMessage: 'Add reviewers',
  },
  addReviewGroup: {
    id: 'frontbucket.repository.pullRequest.reviewGroups.placeholder.addReviewGroup',
    description:
      'Placeholder text to display on the review groups field to create pull request',
    defaultMessage: 'Add review group',
  },
  draftPrHelperText: {
    id: 'frontbucket.createPullRequest.draftPrHelperText',
    description: 'Helper text for draft pull request',
    defaultMessage:
      'For drafts, reviewers will be notified when the pull request is ready.',
  },
});
